<template>
  <div class="row">
    <ProductCard
      v-for="product in this.$store.getters.filteredProducts"
      v-bind:key="product.id"
      v-bind:product="product"
    ></ProductCard>
  </div>
</template>

<script>
import ProductCard from "./ProductCard/ProductCard";
export default {
  components: {
    ProductCard,
  },
  name: "ProductBoard",
  methods: {},
};
</script>]
